import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import '../styles/carousel.css';

const IMAGE_FILE_TYPES = ['jpg', 'jpeg', 'png', 'gif'];

const getFileType = (url) => {
  return url.split('.').pop().toLowerCase();
};

const CoverflowSwiper = ({ images }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const renderMedia = (item) => {
    const fileType = getFileType(item.url);
    if (IMAGE_FILE_TYPES.includes(fileType)) {
      return <img className="full-size-image" src={item.url} alt={item.title} />;
    } else if (fileType === 'mp4') {
      return (
        <video className="full-size-video" controls>
          <source src={item.url} type="video/mp4" />
          Your browser does not support this video format.
        </video>
      );
    } else {
      return <div className="media-not-supported">Media format not supported</div>;
    }
  };

  const goPrev = () => {
    setSelectedIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goNext = () => {
    setSelectedIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={5}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[EffectCoverflow, Navigation, Pagination]}
        className="mySwiper"
      >
        {images.map((item, index) => (
          <SwiperSlide key={index} onClick={() => setSelectedIndex(index)}>
            {IMAGE_FILE_TYPES.includes(getFileType(item.url)) ? (
              <img src={item.url} alt={item.title} />
            ) : getFileType(item.url) === 'mp4' ? (
              <video muted autoPlay loop>
                <source src={item.url} type="video/mp4" />
              </video>
            ) : (
              <div className="non-image-placeholder">Non-image file</div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="full-size-image-container">
        {renderMedia(images[selectedIndex])}
        <div id="nav">
          <button onClick={goPrev} className="button">Prev</button>
          <button onClick={goNext} className="button">Next</button>
        </div>
      </div>
    </>
  );
};

export default CoverflowSwiper;
